/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { OTPInput } from 'Components/OTPInput';
import axios from 'axios';
import { encryptedKeyForCredentials } from 'Commons';
import { AxiosCancelToken, dataFetcher, endpoints, baseUrl } from 'Api';
import { Pathname } from 'Routes';
import { Button } from 'Components';
import { AppContext, AuthContext } from 'Context';
import { isMobile } from 'react-device-detect';
import { AuthPage } from '../components/page';
import { Snackbar } from '../../../../Components/index';
import styles from './verificationCode.module.css';

export const NewVerificationEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    setAppSnackbar,
    userDetails,
    setUserDetails,
    plansPage,
    setPlansPage,
    langText,
    setReferralStatus,
  } = useContext(AppContext);
  const { forceAutoSignin, setToken, getToken, setEmailVerified } = useContext(AuthContext);

  // Check if this is a desktop app flow
  const isDesktopApp = sessionStorage.getItem('isDesktopApp') === 'true';
  const isWindowsDesktop = sessionStorage.getItem('isWindowsDesktop') === 'true';
  const mobileVerificationText = langText?.mobileVerification;
  const commonText = langText?.common;
  const signUpText = langText?.signInUp;
  const OTP_RESEND_TIME = 60;
  const [expireTime, setExpireTime] = useState(OTP_RESEND_TIME);
  const [OTP, setOTP] = useState({
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
  });
  const [otpFinal, setOtpFinal] = useState();
  // const [OTP, setOTP] = useState('');
  const email = sessionStorage.getItem(encryptedKeyForCredentials.email);
  // const mobile = sessionStorage.getItem(encryptedKeyForCredentials.mobile);
  const password = sessionStorage.getItem(encryptedKeyForCredentials.password);
  const [mobile, setMobile] = useState(
    sessionStorage.getItem(encryptedKeyForCredentials.mobile)
  );
  const [isOtpReached, setOtpReached] = useState(true);
  const [first, setfirst] = useState(true);
  const [sendOtpCount, setSendOtpCount] = useState(0);
  const [pastedValue, setPastedValue] = useState('');
  const token = getToken();
  const firstInput = useRef();
  const secondInput = useRef();
  const thirdInput = useRef();
  const fourthInput = useRef();
  const fifthInput = useRef();
  const re = /^[0-9\b]+$/;
  const sendOtpToEmail = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/sendOtpToEmail`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setAppSnackbar({
        message: 'Code sent successfully',
        isVisible: true,
      });
    } catch (error) {
      console.error(
        'Error sending OTP:',
        error.response?.data || error.message
      );
    }
  };
  useEffect(() => {
    sendOtpToEmail();
  }, []);

  const defaultSnackbar = { isVisible: false, message: '', type: '' };
  const [snackbarData, setSnackbar] = useState(defaultSnackbar);
  const { isValidating: verifyingOTP, mutate: verifyOtp } = useSWR(
    [endpoints.verifyOTPEmail, otpFinal, email],
    {
      fetcher: (url, code, email) => dataFetcher(url, { code, email }),
      onSuccess: ({ success, message, token, api_response, has_logged_in, isNewUser }) => {
        if (success) {
          setToken(token);
          forceAutoSignin();

          // Handle desktop app callback for successful email verification
          if (isDesktopApp) {
            const callbackScheme = isWindowsDesktop ? 'http://localhost:8080/callback' : 'projector-app://callback';
            const callbackUrl = `${callbackScheme}?${new URLSearchParams({
              token: api_response?.access || '',
              projector_token: token || '',
              email,
              isNewUser
            }).toString()}`;
            window.location.href = callbackUrl;
            return;
          }

          if (has_logged_in === 0) {
            setTimeout(() => {
              navigate(Pathname.authentication.access);
            }, 100);
          } else {
            setTimeout(() => {
              navigate(Pathname.authentication.avatar);
            }, 100);
          }
        } else {
          setAppSnackbar({
            message: message || 'Oops! Something went wrong',
            isVisible: true,
          });
        }
      },
      onError: (error) => {
        const responseData = error?.response?.data;

        // Handle desktop app callback for email verification errors
        if (isDesktopApp) {
          const callbackScheme = isWindowsDesktop ? 'http://localhost:8080/callback' : 'projector-app://callback';
          window.location.href = `${callbackScheme}?error=${encodeURIComponent(responseData?.message || 'Email verification failed')}`;
          return;
        }

        setSnackbar({ isVisible: true, message: responseData?.message });
        setAppSnackbar({
          message: responseData?.message || 'Oops! Something went wrong',
          isVisible: true,
        });
      },
    }
  );

  const { isValidating: requestingCode, mutate: requestVerificationCode } = useSWR([endpoints.sendOtpToMobile, email, sessionStorage.getItem('mvt')], {
      fetcher: (url, email, token) => dataFetcher(url, { email, token }),
      onSuccess: ({ success, message }) => {
        if (success) {
          setOtpReached(true);
          setSendOtpCount(1);
          setAppSnackbar({ message: message || 'Otp Resend', isVisible: true });
        } else {
          setAppSnackbar({
            message: message || 'Oops! Something went wrong',
            isVisible: true,
          });
        }
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setAppSnackbar({
          message: responseData?.message || 'Oops! Something went wrong',
          isVisible: true,
        });
      },
    });

  useEffect(() => {
    if (isOtpReached) {
      if (!expireTime) return;
      const intervalId = setInterval(() => {
        setExpireTime(expireTime - 1);
      }, 1000);
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
    }
  }, [expireTime, isOtpReached]);

  useEffect(() => {
    if (!sendOtpCount && !isOtpReached) {
      // requestVerificationCode();
    } else {
      setOtpReached(true);
      sessionStorage.removeItem('#fs656gfhllh@#$');
    }
  }, [sendOtpCount, isOtpReached]);

  useEffect(() => {
    setOtpFinal(`${OTP.one}${OTP.two}${OTP.three}${OTP.four}${OTP.five}`);
  }, [OTP]);

  /** Change state of input according to pasted data */
  useEffect(() => {
    if (pastedValue.length === 5) {
      setOTP({
        one: pastedValue[0],
        two: pastedValue[1],
        three: pastedValue[2],
        four: pastedValue[3],
        five: pastedValue[4],
      });
      setPastedValue('');
      fifthInput?.current.focus();
    }
  }, [pastedValue]);

  const resendCodeHandler = () => {
    setExpireTime(OTP_RESEND_TIME);
    setSendOtpCount(0);
    sendOtpToEmail();
  };

  function handleOtpInput(value, otpInputPos, nextInput, prevInput) {
    if (value && value !== '' && nextInput) {
      nextInput?.current.focus();
    } else if ((!value || value === '') && prevInput) {
      prevInput?.current.focus();
    }
    if (value?.length <= 1) {
      setOTP({ ...OTP, [otpInputPos]: value });
    }
  }

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = event.clipboardData.getData('text');
    if (paste.length <= 5) {
      setPastedValue(paste);
    }
  };

  return (
    <>
      <div style={{ marginTop: '-50px' }}>
        <AuthPage>
          {!isMobile && (
            <div
              style={{ marginTop: '50px' }}
              aria-hidden="true"
              onClick={() => {
                navigate(-1);
              }}
              className={styles.backLink}
            >
              {commonText?.back || 'BACK'}
            </div>
          )}
          {isOtpReached ? (
            <form
              onPaste={handlePaste}
              className={styles.alignForm}
              onSubmit={(e) => {
                e.preventDefault();
                verifyOtp();
              }}
            >
              <div className={styles.inputLabel}>
                Enter your one time password
              </div>
              <div className={styles.description}>
                <div>
                  A code was send to your email
                  {/* {' '}
{email || 'your email'} */}
                  , please check and enter code below.
                </div>
                <div>
                  If you do not see the code please try to resend in &nbsp;
                  <span style={{ color: 'white' }}>{`${expireTime}s`}</span>
                </div>
              </div>
              {/* <span style={{ textAlign: 'center' }} className={styles.description}>{`A code was send to your number ${mobile || userDetails?.mobile}, please check and enter below. If you do not see the code please try to resend in `}</span>
                <span className={styles.expireTime}>{`${expireTime}s`}</span> */}
              <br />
              <br />
              <div className={styles.buttonBlock}>
                <div style={{ paddingLeft: '8px', display: 'flex' }}>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.one}
                      ref={firstInput}
                      onChange={(event) => handleOtpInput(event.target.value, 'one', secondInput)}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !OTP.one) {
                          firstInput.current.focus();
                        }
                      }}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.two}
                      ref={secondInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'two',
                          thirdInput,
                          firstInput
                        )}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !OTP.two) {
                          firstInput.current.focus();
                          setOTP((prev) => ({ ...prev, one: '' }));
                        }
                      }}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.three}
                      ref={thirdInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'three',
                          fourthInput,
                          secondInput
                        )}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !OTP.three) {
                          secondInput.current.focus();
                          setOTP((prev) => ({ ...prev, two: '' }));
                        }
                      }}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.four}
                      ref={fourthInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'four',
                          fifthInput,
                          thirdInput
                        )}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !OTP.four) {
                          thirdInput.current.focus();
                          setOTP((prev) => ({ ...prev, three: '' }));
                        }
                      }}
                      className={styles.codeInput}
                    />
                  </div>
                  <div style={{ paddingRight: '18px' }}>
                    <input
                      type="number"
                      max={9}
                      value={OTP.five}
                      ref={fifthInput}
                      onChange={(event) => handleOtpInput(
                          event.target.value,
                          'five',
                          null,
                          fourthInput
                        )}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !OTP.five) {
                          fourthInput.current.focus();
                          setOTP((prev) => ({ ...prev, four: '' }));
                        }
                      }}
                      className={styles.codeInput}
                    />
                  </div>
                </div>

                {/* <input
                    type="tel"
                    maxLength={5}
                    value={OTP}
                    onChange={handleChange}
                    style={{ width: '200px', height: '55px', borderRadius: '10px', backgroundColor: '#31343e', border: '2px solid #6d6f76', color: '#ffffff', fontSize: '20px', fontWeight: '700', textAlign: 'center' }}
                  /> */}
                {/* <OTPInput className={styles.otpInputs} inputStyles={{ width: '60px', height: '55px', borderRadius: '10px', backgroundColor: '#31343e', border: '2px solid #6d6f76', color: '#ffffff', fontSize: '20px', fontWeight: '700' }} value={OTP} onChange={setOTP} autoFocus OTPLength={5} otpType="number" disabled={false} /> */}
              </div>
              <br />
              <div className={styles.buttonBlock}>
                <Button
                  isFullWidth
                  blockText
                  isDisabled={
                    !otpFinal || otpFinal?.length !== 5 || verifyingOTP
                  }
                  isBlue
                  isLarge
                  submit
                >
                  {mobileVerificationText?.continue || 'Continue'}
                </Button>
              </div>
            </form>
          ) : null}
          <div
            className={styles.resendDiv}
            // onClick={() => { setExpireTime(120); setSendOtpCount(0); }}
          >
            <button
              style={{ borderStyle: 'none', marginTop: '-0px' }}
              onClick={() => {
                resendCodeHandler();
              }}
              disabled={expireTime !== 0}
            >
              {mobileVerificationText?.resendLink || 'Resend Code'}
            </button>
          </div>
          <Snackbar
            {...snackbarData}
            onClose={() => {
              setSnackbar({ ...snackbarData, isVisible: false });
            }}
          />
        </AuthPage>
      </div>
    </>
  );
};
